(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-box-tag"] && !Shopify.designMode) return;
  try {
    
// Slider for logos
const newCustomCarousel = document.querySelector('.new-custom-icon-carousel');

if (newCustomCarousel) {
  let carouselItems = Array.from(newCustomCarousel.children);
  const gap = 20;
  let visibleCount = window.innerWidth <= 767 ? 2 : 4;

  const cloneStart = carouselItems.map(item => item.cloneNode(true)).reverse();
  const cloneEnd = carouselItems.map(item => item.cloneNode(true));
  cloneStart.forEach(item => newCustomCarousel.insertBefore(item, newCustomCarousel.firstChild));
  cloneEnd.forEach(item => newCustomCarousel.appendChild(item));

  carouselItems = Array.from(newCustomCarousel.children);
  let currentIdx = visibleCount;

  function updateCarousel(transition = true) {
    const itemWidth = carouselItems[0].offsetWidth + gap;
    newCustomCarousel.style.transition = transition ? 'transform 0.5s ease-in-out' : 'none';
    newCustomCarousel.style.transform = `translateX(-${itemWidth * currentIdx}px)`;
  }

  function slideCarousel() {
    currentIdx += 1;
    updateCarousel(true);
    const originalLength = (carouselItems.length - 2 * visibleCount);
    if (currentIdx >= originalLength + visibleCount) {
      setTimeout(() => {
        currentIdx = visibleCount;
        updateCarousel(false);
      }, 500);
    }
  }

  window.addEventListener('resize', () => {
    visibleCount = window.innerWidth <= 767 ? 2 : 4;
    updateCarousel(false);
  });

  updateCarousel(false);
  setInterval(slideCarousel, 3000);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-section"] && !Shopify.designMode) return;
  try {
    
const carousel = document.querySelector('.icon-carousel');
let originalItems = Array.from(carousel.children);
let visibleCount = window.innerWidth <= 768 ? 2 : 7;
let currentIdx = visibleCount; // start after prepended clones

function setupCarousel() {
  // Remove existing clones
  carousel.querySelectorAll('.clone').forEach(clone => clone.remove());

  // Clone first and last N items (N = visibleCount) for seamless loop
  const items = Array.from(carousel.children);
  const startClones = items.slice(-visibleCount).map(item => {
    const clone = item.cloneNode(true);
    clone.classList.add('clone');
    return clone;
  });
  const endClones = items.slice(0, visibleCount).map(item => {
    const clone = item.cloneNode(true);
    clone.classList.add('clone');
    return clone;
  });

  startClones.forEach(clone => carousel.insertBefore(clone, carousel.firstChild));
  endClones.forEach(clone => carousel.appendChild(clone));

  currentIdx = visibleCount; // reset to first original item
  updateCarousel(true); // skip transition for initial positioning
}

function updateCarousel(skipTransition = false) {
  const itemWidth = carousel.querySelector('.icon-carousel-item').offsetWidth + 20; // width + gap
  carousel.style.transition = skipTransition ? 'none' : 'transform 0.5s ease-in-out';
  carousel.style.transform = `translateX(-${itemWidth * currentIdx}px)`;
}

function slideCarousel() {
  currentIdx++;
  updateCarousel();

  const items = carousel.querySelectorAll('.icon-carousel-item, .clone');
  const originalLength = originalItems.length;

  if (currentIdx >= originalLength + visibleCount) {
    // Jump back to first original item after last clone
    setTimeout(() => {
      currentIdx = visibleCount;
      updateCarousel(true);
    }, 500);
  }
}

window.addEventListener('resize', () => {
  visibleCount = window.innerWidth <= 768 ? 2 : 7;
  setupCarousel();
});

// Initialize
setupCarousel();
setInterval(slideCarousel, 3000);

// Initialize position
updateCarousel();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["towel-carousel"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.custom-carousel', {
  slidesPerView: 3,        // Show 3 slides first
  spaceBetween: 20,
  direction: 'horizontal',  
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1024: { slidesPerView: 3 },
    768: { slidesPerView: 2 },
    480: { slidesPerView: 1 }
  }
});

  } catch(e) { console.error(e); }
})();
})();
